// ============================================================================
// QuickLinksCard — liens rapides personnels (rail accueil)
// ============================================================================
// Titre de section parent (gest:accueil.rail.*) ; cette carte n'a plus d'en-tete
// RailCard propre. Mon equipe gate capability-aware (M-150).

import { Link } from 'react-router-dom';
import type { LucideIcon } from 'lucide-react';
import { ChevronRight, User, Users, Wallet } from 'lucide-react';
import { useTranslation } from '../../i18n';
import { RailCard } from './RailCard';

const LINK_ROW =
  'group flex min-h-11 items-center gap-3 rounded-xl px-1 py-2 touch-manipulation ' +
  'transition-colors hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 ' +
  'focus-visible:ring-brand-500 focus-visible:ring-offset-2 dark:hover:bg-slate-900/40 ' +
  'dark:focus-visible:ring-offset-slate-800';

function QuickLinkRow({
  to,
  label,
  icon: Icon,
}: {
  to: string;
  label: string;
  icon: LucideIcon;
}) {
  return (
    <li>
      <Link to={to} className={LINK_ROW}>
        <span
          className="flex shrink-0 items-center justify-center rounded-xl bg-slate-50 p-2.5 dark:bg-slate-900/40"
          aria-hidden="true"
        >
          <Icon size={20} className="text-slate-600 dark:text-slate-400" />
        </span>
        <span className="min-w-0 flex-1 text-field font-medium text-slate-700 dark:text-slate-200">
          {label}
        </span>
        <ChevronRight
          size={16}
          aria-hidden="true"
          className="shrink-0 text-slate-300 transition-colors group-hover:text-slate-400 dark:text-slate-600 dark:group-hover:text-slate-500"
        />
      </Link>
    </li>
  );
}

export interface QuickLinksCardProps {
  /** M-150 : true apres probe GET /api/mon-equipe 200 (director|admin). */
  canViewMonEquipe: boolean;
  className?: string;
}

export function QuickLinksCard({ canViewMonEquipe, className }: QuickLinksCardProps) {
  const { t } = useTranslation();

  return (
    <RailCard className={className}>
      <nav aria-label={t('gest:accueil.quickLinks.ariaLabel')}>
        <ul className="divide-y divide-slate-100 dark:divide-slate-700/60">
          <QuickLinkRow
            to="/profile"
            label={t('gest:accueil.quickLinks.myProfile')}
            icon={User}
          />
          <QuickLinkRow
            to="/profile?tab=remuneration"
            label={t('gest:accueil.quickLinks.myCompensation')}
            icon={Wallet}
          />
          {canViewMonEquipe ? (
            <QuickLinkRow
              to="/mon-equipe"
              label={t('gest:accueil.quickLinks.myTeam')}
              icon={Users}
            />
          ) : null}
        </ul>
      </nav>
    </RailCard>
  );
}
